export const TAGLINE = 'GO BEYOND';

export const ASSETS = {
  badge: '/assets/badge-logo.png',
  logo: '/assets/logo-prokrisp-v2.png',
  mural: '/assets/mural.jpg',
  muralTop: '/assets/mural-top.jpg',
  muralContact: '/assets/mural-contact.jpg',
  soon: '/assets/pack-soon.png',
  chips: '/assets/chips.png',
  box50: '/assets/box-50.png',
  box100: '/assets/box-100.png',
};
export const CHIPS = [0, 1, 2, 3, 4, 5].map((i) => `/assets/chip-${i}.png`);

export const VARIANTS = [
  { id: '50g', name: '50G', label: 'PROKRISP 50G', sub: '50G MULTIGRAIN CHIPS', price: 50, mrp: 60, protein: '15G', img: 'img50' },
];

export const WHATSAPP = { display: '+91 92208 88136', number: '919220888136' };
export const waLink = (msg) => `https://wa.me/${WHATSAPP.number}?text=${encodeURIComponent(msg)}`;
export const MIN_ORDER_QTY = 3;
export const PACK = VARIANTS[0];
export const variantOf = (id) => VARIANTS.find((v) => v.id === id) || PACK;
export const variantLabel = (id) => variantOf(id).sub;
export const priceOf = (slug, id) => variantOf(id).price;

export const NUTRITION = [
  ['Energy', '215 kcal'],
  ['Protein', '15 g'],
  ['Total Fat', '7 g'],
  ['Saturated Fat', '1 g'],
  ['Carbohydrates', '26 g'],
  ['Dietary Fibre', '4 g'],
  ['Sodium', '320 mg'],
];

export const FLAVORS = {
  'masala-krunch': {
    slug: 'masala-krunch',
    name: 'MASALA KRUNCH',
    short: 'MASALA',
    tagline: 'BOLD. SPICED. BUILT TO FUEL.',
    hook: 'CHILLI · TOMATO · INDIAN SPICES',
    color: '#E11D24',
    tint: '#F7D6D2',
    img50: '/assets/pack50-masala.png',
    img100: '/assets/pack100-masala.png',
    ingredients: 'Multigrain Blend (Corn, Wheat, Millet, Rice), Pea Protein, Edible Vegetable Oil (Sunflower), Masala Seasoning (Chilli, Tomato, Onion, Garlic, Spices), Salt, Yeast Extract.',
  },
  'cheese-herbs': {
    slug: 'cheese-herbs',
    name: 'CHEESE & HERBS',
    short: 'CHEESE',
    tagline: 'RICH. HERBY. ROASTED TO PERFECTION.',
    hook: 'CHEDDAR · PARSLEY · OREGANO',
    color: '#F7B500',
    tint: '#FBEBC2',
    img50: '/assets/pack50-cheese.png',
    img100: '/assets/pack100-cheese.png',
    ingredients: 'Multigrain Blend (Corn, Wheat, Millet, Rice), Pea Protein, Edible Vegetable Oil (Sunflower), Cheese & Herb Seasoning (Cheese Powder, Parsley, Oregano, Garlic), Salt, Yeast Extract.',
  },
};

export const FLAVOR_LIST = Object.values(FLAVORS);

export const MYSTERY = {
  slug: 'flavour-3',
  name: 'FLAVOUR #3',
  short: '???',
  tagline: 'COMING SOON. STAY TUNED.',
  hook: 'YOU PICK THE NEXT ONE',
  color: '#E0632A',
  tint: '#F3DDC9',
  img50: '/assets/pack-soon.png',
  img100: '/assets/pack-soon.png',
  soon: true,
};

export const VOTE_OPTIONS = [
  { id: 'salt-pepper', name: 'SALT & PEPPER', desc: 'Cracked pepper. Sea salt. Classic done loud.', color: '#3A3A3A' },
  { id: 'tomato', name: 'TOMATO', desc: 'Tangy, sun-dried, dangerously snackable.', color: '#D8452B' },
  { id: 'sweet-chilli', name: 'SWEET CHILLI', desc: 'Heat that hits, sweetness that stays.', color: '#E0632A' },
  { id: 'pudina', name: 'PUDINA', desc: 'Cool mint, desi kick. Refresh and repeat.', color: '#3E9B4F' },
];

export const SKUS = VARIANTS.flatMap((v) => FLAVOR_LIST.map((f) => ({ flavor: f, variant: v, key: v.id === '50g' ? f.slug : `${f.slug}-${v.id}` })));
export const SKUS_50 = SKUS.filter((s) => s.variant.id === '50g');
export const SKUS_100 = [];

export const ALLERGEN = 'Contains Wheat, Milk. May contain traces of Soy and Nuts.';

export const SPECS = ['15G PROTEIN', 'ROASTED & PLANT BASED', 'NO PALM OIL', 'NO ARTIFICIAL COLOURS', 'MULTIGRAIN'];

export const GIFT_BOXES = [
  { id: 'box50', name: 'THE 50G GIFT BOX', desc: 'Four 50g packs — two Masala Krunch, two Cheese & Herbs — in a gold-foiled black box. Go beyond the ordinary.', items: '4 × 50G', price: 299, mrp: 360, color: '#F7B500', img: ASSETS.box50 },
  { id: 'box100', name: 'THE 100G POWER BOX', desc: 'Two big pouches plus a PROKRISP shaker. Built for people who train. Enquire on WhatsApp.', items: '2 POUCHES + SHAKER', price: 599, mrp: 720, color: '#E11D24', img: ASSETS.box100 },
];

export const POLICIES_PDF = '/assets/prokrisp-policies.pdf';

export const SOCIALS = [
  { id: 'instagram', name: 'INSTAGRAM', handle: '@pro.krisp', href: 'https://www.instagram.com/pro.krisp/', color: '#E11D24', live: true },
  { id: 'linkedin', name: 'LINKEDIN', handle: 'PROKRISP', href: 'https://www.linkedin.com/company/prokrisp', color: '#0A66C2', live: true },
  { id: 'youtube', name: 'YOUTUBE', handle: '@Pro-Krisps', href: 'https://www.youtube.com/@Pro-Krisps', color: '#FF0000', live: true },
];

export const CONTACTS = [
  { label: 'GENERAL ENQUIRIES', value: 'hello@prokrisp.com', href: 'mailto:hello@prokrisp.com' },
  { label: 'PARTNERSHIPS & GROWTH', value: 'growth@prokrisp.com', href: 'mailto:growth@prokrisp.com' },
  { label: 'BUSINESS & OPERATIONS', value: 'business@prokrisp.com', href: 'mailto:business@prokrisp.com' },
  { label: 'WEBSITE', value: 'www.prokrisp.com', href: 'https://www.prokrisp.com' },
  { label: 'PHONE', value: '+91 9220888136', href: 'tel:+919220888136' },
];

export const TEAM = [
  { who: 'HEERRANJ GUPTA', name: 'MANAGING DIRECTOR', bio: 'Sets the direction. Keeps the crunch honest and the brand bold.', color: '#E11D24' },
  { who: 'RUDRA SHAH', name: 'PARTNERSHIPS & LOGISTICS DIRECTOR', bio: 'Builds the partnerships and moves every pack from oven to doorstep.', color: '#F7B500' },
  { who: 'DARSHIL KACHHALA', name: 'OPERATIONS & FINANCE DIRECTOR', bio: 'Runs the day-to-day and makes sure the numbers add up.', color: '#E0632A' },
  { who: 'TUVIJEET SHARMA', name: 'FINANCE & SALES DIRECTOR', bio: 'Owns the sales pipeline and the balance sheet.', color: '#3E9B4F' },
  { who: 'TANISHA VELANI', name: 'MANUFACTURING & PRODUCT DIRECTOR', bio: 'Perfects the recipe, the roast and every pack that leaves the line.', color: '#7A1E1E' },
  { who: 'CATALINA VICTORIA', name: 'BRAND & MARKETING DIRECTOR', bio: 'Shapes the look, the voice and the community around PROKRISP.', color: '#F5A623' },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: 'smooth' });
};
